import * as React from 'react';

import iconUrl from './MortgageIcon.svg';

export const MortgageIcon = () => <img width="32" height="36" src={iconUrl} alt="" />;

MortgageIcon.displayName = 'MortgageIcon';
